import * as React from "react";

export const IconFileExportFill = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.20964 18.6462L3.04297 17.4587L5.5013 15.0003H3.6263L3.6263 13.3337H8.33464L8.33464 18.042H6.66797L6.66797 16.1878L4.20964 18.6462ZM10.0013 18.3337L10.0013 11.667L3.33464 11.667L3.33464 3.33366C3.33464 2.87533 3.49783 2.48296 3.82422 2.15658C4.15061 1.83019 4.54297 1.66699 5.0013 1.66699L11.668 1.66699L16.668 6.66699V16.667C16.668 17.1253 16.5048 17.5177 16.1784 17.8441C15.852 18.1705 15.4596 18.3337 15.0013 18.3337L10.0013 18.3337ZM10.8346 7.50033L15.0013 7.50033L10.8346 3.33366V7.50033Z"
        fill="currentColor"
      />
    </svg>
  );
};
